import React from 'react';
import {
  Button
} from '@material-ui/core';
import '../Dialog/index.less';
import commonLabels from '../../../constants/messageConstants';
import { getCurrentPayCycle, IsComplianceAccess, IsYearEndBonusAccess, IsYearEndBonusEstimationReviewAccess } from '../../../utils/helper';
import ConfirmDialog from '../Dailogbox/confirmDailog';
import { apiBatchRequest, apiPost } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import { ShowToast, toastType } from '../../../utils/toast-service';
import store from '../../../store/appStore';
import moment from 'moment';
import { DateFormat } from '../../../constants/appConstants';

// Component to show Allocation-Due banner
class Banner extends React.PureComponent {
  // Constructor to set initial state of component
  constructor (props) {
    super(props);
    this.state = {
      open: false,
      isBanner: false,
      complianceData: [],
      periodStartDate: null,
      periodEndDate: null,
      userData: this.props.userData,
      yearEndBonus: null,
      showAllocationComplianceBanner: this.props.userData?.complianceDates?.isCompleted === false,
      popupType: '',
      confirmTitle: '',
      submitTitle: '',
      cancelTitle: ''
    };
  }

  // Get data from API before components are mounted
  componentDidMount () {
    this.loadData(true);
  }

  // Get Allocation compliance details
  GetComplianceData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetYearEndComplianceStatus + '?periodStartDate=' + moment().format(DateFormat),
        key: 'complianceData'
      }
    ])
      .then(
        ({
          complianceData
        }) => {
          this._asyncRequest = null;
          if (complianceData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            this.setState({
              yearEndBonus: complianceData.data?.length > 0 ? complianceData.data[0] : null,
              confirmationMessage: '',
              open: false,
              confirmTitle: '',
              submitTitle: '',
              cancelTitle: ''
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Load master data 
  loadData = (isYearEndBonusLoad = false) => {
    const date = getCurrentPayCycle();
    const email = (((store.getState() || {}).auth || {}).account || {}).username || '';

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetAllocationComplianceDetail + '?periodStartDate=' + date[1] + '&periodEndDate=' + date[0] + '&Email=' + email,
        key: 'complianceData'
      }
    ])
      .then(
        ({
          complianceData
        }) => {
          this._asyncRequest = null;
          if (complianceData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            const complianceUserData = complianceData.data?.length > 0 ? complianceData.data.find(x => x.userEmail.toString().toLowerCase() === email.toString().toLowerCase() && x.isCompleted === false) : undefined;
            this.setState({
              // isBanner: (complianceUserData !== undefined && moment().format(DateFormat) >= moment(complianceUserData?.allocationDueDate).subtract(6, 'days').format(DateFormat)),
              isBanner: (complianceUserData !== undefined), // && moment().format(DateFormat) >= moment(complianceUserData?.nofifyFrom).format(DateFormat)),
              complianceData: complianceUserData,
              confirmationMessage: '',
              open: false,
              confirmTitle: '',
              submitTitle: '',
              cancelTitle: '',
              periodStartDate: date[1],
              periodEndDate: date[0]
            }, () => {
              if (isYearEndBonusLoad === true) {
                this.GetComplianceData();
              }
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Open confirmation popup
  openPopup = (value) => {
    let confirmationMessage = '';
    let confirmTitle = '';
    let submitTitle = '';
    let cancelTitle = '';
    if (value === 'AllocationCompliance') {
      confirmationMessage = <>I Have Completed My Allocations and I Am Certifying They are Correct to The Best of My Knowledge</>;
      confirmTitle = 'CONFIRM YOUR ALLOCATIONS ARE COMPLETE';
      submitTitle = 'MY ALLOCATIONS ARE COMPLETE';
      cancelTitle = 'NO, ALLOCATIONS ARE NOT COMPLETE - CANCEL';
    } else if (value === 'BonusEstimations') {
      confirmationMessage = <>I Have Completed My Bonus Estimations and I Am Certifying They are Correct to The Best of My Knowledge</>;
      confirmTitle = 'CONFIRM YOUR BONUS ESTIMATIONS ARE COMPLETE';
      submitTitle = 'MY BONUS ESTIMATIONS ARE COMPLETE';
      cancelTitle = 'NO, BONUS ESTIMATIONS ARE NOT COMPLETE - CANCEL';
    } else if (value === 'BonusReview') {
      confirmationMessage = <>I Have Completed My Bonus Review and I Am Certifying They are Correct to The Best of My Knowledge</>;
      confirmTitle = 'CONFIRM YOUR BONUS REVIEW IS COMPLETE';
      submitTitle = 'MY BONUS REVIEW IS COMPLETE';
      cancelTitle = 'NO, BONUS REVIEW IS NOT COMPLETE - CANCEL';
    }
    this.setState({
      confirmationMessage,
      confirmTitle,
      submitTitle,
      cancelTitle,
      open: true,
      popupType: value
    });
  }

  // Click event of actions on Confirmation dialog box
  onPopupClickHandle = (isYes) => {
    const { popupType } = this.state;
    if (isYes) {
      if (popupType === 'AllocationCompliance') { this.GetPeriodData(); } else if (popupType === 'BonusEstimations' || popupType === 'BonusReview') { this.UpdateYearEndBonusComplianceDetail(); }
    } else {
      this.setState({
        confirmationMessage: '',
        open: false,
        confirmTitle: '',
        submitTitle: '',
        cancelTitle: ''
      });
    }
  }

  // Get Pay Periods data
  GetPeriodData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodData'
      }
    ])
      .then(
        ({
          payPeriodData
        }) => {
          this._asyncRequest = null;
          if (payPeriodData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            const payPeriodId = payPeriodData.data.find(x => x.payPeriod === (this.state.periodStartDate + '-' + this.state.periodEndDate))?.payPeriodId;
            this.UpdateAllocationComplianceDetail(payPeriodId);
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Update Allocation compliance details
  UpdateAllocationComplianceDetail = (payPeriodId) => {
    const complianceUserData = {
      PayPeriodId: payPeriodId,
      IsCompleted: true
    };
    apiPost({
      url: API_URL.Allocation.UpdateAllocationComplianceDetail,
      params: {},
      postBody: complianceUserData
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast('Thanks for completing your Allocations till the current pay cycle.', toastType.SUCCESS, 5000, 500);
        this.loadData();
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
        this.setState({
          isSave: false
        });
      }
    });
  }

  // Update Year End Bonus Compliance details
  UpdateYearEndBonusComplianceDetail = () => {
    const { yearEndBonus, popupType } = this.state;
    const complianceUserData = {
      yearEndBonusConfigurationId: yearEndBonus.yearEndBonusConfigurationId,
      periodStartDate: yearEndBonus.processEndDate,
      yearEndComplianceStatusId: yearEndBonus.yearEndComplianceStatusId,
      reviewStatus: popupType === 'BonusReview' ? true : yearEndBonus.reviewStatus,
      estimationStatus: popupType === 'BonusEstimations' ? true : yearEndBonus.estimationStatus
    };
    apiPost({
      url: API_URL.Users.UpdateYearEndComplianceStatus,
      params: {},
      postBody: complianceUserData
    }).then(({ data: response }) => {
      if (response.success) {
        if (popupType === 'BonusEstimations') {
          ShowToast('Thanks for completing your bonus estimations till the current year.', toastType.SUCCESS, 5000, 500);
        } else {
          ShowToast('Thanks for completing your bonus review till the current year.', toastType.SUCCESS, 5000, 500);
        }
        this.GetComplianceData();
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
        this.setState({
          isSave: false
        });
      }
    });
  }

  // Render components based on conditions
  render () {
    const { confirmTitle, submitTitle, cancelTitle, open, confirmationMessage, isBanner, showAllocationComplianceBanner, yearEndBonus } = this.state;
    return (
      <>
        {open && (
          <ConfirmDialog
            IsOpen={open}
            Message={confirmationMessage}
            Title={confirmTitle}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText={submitTitle} // "Submit"
            DisAgreeText={cancelTitle} // "Cancel"
          />
        )}
        {IsComplianceAccess() && showAllocationComplianceBanner && isBanner === true &&
          <div className="layout-banner-wrapper">
            <div className='row'>
              <div className='col-sm-10'>
                <div className='banner-text'>
                  Your Allocations are due on <b>{moment(this.state.complianceData?.allocationDueDate).format('MM/DD/YYYY')}</b>. Please complete your Allocations by the due date. If your Allocations are done, please click the <b>I AM DONE </b> button.
               </div>
              </div>
              <div className="col-sm-2">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className='pull-right banner-btn'
                  onClick={() => {
                    this.openPopup('AllocationCompliance');
                  }}
                >
                  I am done
              </Button>
              </div>
            </div>
          </div>
        }
        {IsYearEndBonusAccess() && yearEndBonus !== null && IsYearEndBonusEstimationReviewAccess(yearEndBonus, true) &&
          <div className="layout-banner-wrapper">
            <div className='row margin-top-bottom'>
              <div className='col-sm-9'>
                <div className='banner-text'>
                  Your Year End Bonus Estimations are due on <b>{moment(this.state.yearEndBonus?.allocationPeriodEndDate).format('MM/DD/YYYY')}</b>. Please complete your bonus estimations before the due date. If your Bonus Estimations are done, please click on the <b>I AM DONE WITH BONUS ESTIMATIONS</b> button.
                </div>
              </div>
              <div className="col-sm-3
              ">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className='pull-right banner-btn'
                  onClick={() => {
                    this.openPopup('BonusEstimations');
                  }}
                >
                  I am done With Bonus Estimations
              </Button>
              </div>
            </div>
          </div>
        }
        {IsYearEndBonusAccess() && yearEndBonus !== null && IsYearEndBonusEstimationReviewAccess(yearEndBonus) &&
          <div className="layout-banner-wrapper">
            <div className='row margin-top-bottom'>
              <div className='col-sm-10'>
                <div className='banner-text'>
                  Your Year End Bonus Review is due on <b>{moment(this.state.yearEndBonus?.processEndDate).format('MM/DD/YYYY')}</b>. Please complete your bonus review before the due date. If your Bonus Review is done, please click the <b>I AM DONE WITH BONUS REVIEW</b> button.
               </div>
              </div>
              <div className="col-sm-2">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className='pull-right banner-btn'
                  onClick={() => {
                    this.openPopup('BonusReview');
                  }}
                >
                  I am done With Bonus Review
              </Button>
              </div>
            </div>
          </div>
        }
      </>
    );
  }
}

export default Banner;
